import check from "../assets/icons/aboutrpa/check.png";

const data = [
  {
    id: 1,
    heading: "Discover RPA’s top featurens",
  },
  {
    id: 2,
    img: check,
    title: "Minimal investment",
    para: "RPA is an affordable solution with a quick setup. It can be implemented separately for each process rather than all at once, starting small and building up over time.",
  },
  {
    id: 3,
    img: check,
    title: "Instant benefits",
    para: "ROI can be achieved very quickly with RPA. Implementation takes only weeks for some business processes, and the results can be seen immediately.",
  },
  {
    id: 4,
    img: check,
    title: "Fits existing processes",
    para: "Organizations don’t need to change much about how their teams do things. RPA simply takes over some of the work, focused on powering business processes from behind the scenes.",
  },
  {
    id: 5,
    img: check,
    title: "Business first, supported by technology",
    para: "RPA has a low barrier of entry for users. Only 3% of organizations that introduce RPA face employee resistance at or past the implementation stage.",
  },

  {
    id: 6,
    img: check,
    title: "Scales and adapts easily",
    para: "RPA is a flexible solution that can be customized to fit an organization’s current needs, then expanded with new processes, adjustments, or more data. Without downtime.",
  },
];

export default data;
